import * as THREE from 'three'
import React, {useMemo} from 'react'
import {useGLTF, useMask} from '@react-three/drei'

export function TreeModel({id, ...props}) {
    const {nodes, materials} = useGLTF('./models/tree.glb')

    /*const customTreeMaterials = useMemo(() => {
        const result = {}
        Object.entries(materials).forEach(([name, originalMaterial]) => {
            result[name] = new THREE.MeshBasicMaterial({
                map: originalMaterial.map,
                color: originalMaterial.color,
            })
        })
        return result
    }, [materials])*/
    
    const stencil = useMask(id)
    return (
        <>
            <mesh {...props} dispose={null}
                  geometry={nodes.Vert003.geometry}
            >
                <meshBasicMaterial
                    color={materials['Material.001'].color}
                    {...stencil}
                />
            </mesh>

        </>
    )
}

useGLTF.preload('./models/tree.glb')


